import axios from '../config/axios';
import { AddGuestCartResponse } from '../interface/interface';
import { Endpoints } from './endPoints';

const addGuestProductCart = async (
  productId: string,
  quantity = 1,
): Promise<AddGuestCartResponse> => {
  try {
    const guestCartId = sessionStorage.getItem('guestCartId');
    const guestEmail = sessionStorage.getItem('guestEmail');

    const payload: any = {
      product_id: productId,
      quantity,
    };

    if (guestCartId) {
      payload.cart_id = guestCartId;
    }

    payload.email = guestEmail;

    const response = await axios.post(Endpoints.CREATE_SHIPPING_INFO, payload);
    if (response.status === 200) {
      // If this is the first time, save the cart ID
      if (response.data.newCartCreated && response.data.cartId) {
        // Update localStorage with new cart details
        sessionStorage.setItem('guestCartId', response.data.cartId);

        if (response.data.guestEmail) {
          sessionStorage.setItem('guestEmail', response.data.guestEmail);
        }
      }

      return {
        success: true,
        status: response.status,
      };
    }

    return {
      success: false,
      message: 'Failed to add product to cart',
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    console.error('Error adding product to guest cart:', error);
    return {
      success: false,
      message: error.response?.data?.message || 'Error adding product to cart',
      status: error.response?.status,
    };
  }
};

export default addGuestProductCart;
